document.addEventListener('DOMContentLoaded', () => {
  const dropdowns = [...document.querySelectorAll('.header-nav__dropdown')];
  dropdowns.forEach((dropdown) => {
    dropdown.addEventListener('toggle', () => {
      if (!dropdown.open) return;
      dropdowns.forEach((other) => {
        if (other !== dropdown) other.removeAttribute('open');
      });
    });

    let closeTimeout;
    dropdown.addEventListener('mouseenter', () => {
      clearTimeout(closeTimeout);
      dropdown.setAttribute('open', '');
    });
    dropdown.addEventListener('mouseleave', () => {
      closeTimeout = setTimeout(() => dropdown.removeAttribute('open'), 150);
    });
  });
  document.addEventListener('click', (event) => {
    if (event.target.closest('.header-nav__dropdown')) return;
    dropdowns.forEach((dropdown) => dropdown.removeAttribute('open'));
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    dropdowns.forEach((dropdown) => {
      if (!dropdown.open) return;
      dropdown.removeAttribute('open');
      dropdown.querySelector('summary')?.focus();
    });
  });
});
